import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController, AlertController} from 'ionic-angular';

import { UserProvider } from '../../providers/user';


/**
 * Generated class for the VacationCalendarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-vacation-calendar',
  templateUrl: 'vacation-calendar.html',
})
export class VacationCalendarPage {
    vacationStart;
    vacationEnd;
    mode: string = 'start';
  eventSource = [];
  viewTitle;

  isToday:boolean;
  calendar = {
      autoSelect: false,
      queryMode: 'local',
      mode: 'month',
      noEventsLabel: 'Keine Veranstaltungen',
      currentDate: new Date(),
      dateFormatter: {
          formatMonthViewDay: function(date:Date) {
              return date.getDate().toString();
          },
          formatMonthViewDayHeader: function(date:Date) {
              return 'MonMH';
          },
          formatMonthViewTitle: function(date:Date) {
              return 'testMT';
          },
          formatWeekViewDayHeader: function(date:Date) {
              return 'MonWH';
          },
          formatWeekViewTitle: function(date:Date) {
              return 'testWT';
          },
          formatWeekViewHourColumn: function(date:Date) {
              return 'testWH';
          },
          formatDayViewHourColumn: function(date:Date) {
              return 'testDH';
          },
          formatDayViewTitle: function(date:Date) {
              return 'testDT';
          }
      }
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public viewCtrl: ViewController, private alertCtrl: AlertController) {
      this.mode = this.navParams.get("mode");
      if(this.mode == 'end') {
          this.vacationStart = this.navParams.get("dateFrom");
          let eventStart = new Date(this.vacationStart);
          let eventEnd = new Date(this.vacationStart);
          eventEnd.setDate(eventStart.getDate() + 1);
          this.eventSource = [{
              title: 'Antrag Start',
              startTime: eventStart,
              endTime: eventEnd,
              allDay: false
          }];
          console.log(this.eventSource);
      }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VacationCalendarPage');
  }

  onViewTitleChanged(title) {
      this.viewTitle = title;
  }

  onEventSelected(event) {
      console.log('Event selected:' + event.startTime + '-' + event.endTime + ',' + event.title);
  }

  changeMode(mode) {
      this.calendar.mode = mode;
  }

  today() {
      this.calendar.currentDate = new Date();
  }

  onTimeSelected(ev) {
      if(this.mode == 'start') {
          if(ev.selectedTime < new Date()) {
              this.vacationStart = null;
              let alert = this.alertCtrl.create({
                  title: 'Fehler',
                  subTitle: 'Es können nur Tage ausgewählt werden, die in der Zukunft liegen',
                  buttons: ['Ok']
              });
              alert.present();
          } else {
              this.vacationStart = ev.selectedTime;
          }
      } else if(this.mode == 'end') {
          if(ev.selectedTime < this.vacationStart) {
              this.vacationEnd = null;
              let alert = this.alertCtrl.create({
                  title: 'Fehler',
                  subTitle: 'Es können nur Tage ausgewählt werden, die höher als der Ausgewählte Start sind',
                  buttons: ['Ok']
              });
              alert.present();
          } else if(ev.selectedTime < new Date()) {
              this.vacationStart = null;
              let alert = this.alertCtrl.create({
                  title: 'Fehler',
                  subTitle: 'Es können nur Tage ausgewählt werden, die in der Zukunft liegen',
                  buttons: ['Ok']
              });
              alert.present();
          } else {
              this.vacationEnd = ev.selectedTime;
          }
      }

      console.log('Selected time: ' + ev.selectedTime + ', hasEvents: ' +
          (ev.events !== undefined && ev.events.length !== 0) + ', disabled: ' + ev.disabled);
  }

  onCurrentDateChanged(event:Date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      event.setHours(0, 0, 0, 0);
      this.isToday = today.getTime() === event.getTime();
  }

  createRandomEvents() {
      var events = [];
      for (var i = 0; i < 50; i += 1) {
          var date = new Date();
          var eventType = Math.floor(Math.random() * 2);
          var startDay = Math.floor(Math.random() * 90) - 45;
          var endDay = Math.floor(Math.random() * 2) + startDay;
          var startTime;
          var endTime;
          if (eventType === 0) {
              startTime = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + startDay));
              if (endDay === startDay) {
                  endDay += 1;
              }
              endTime = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + endDay));
              events.push({
                  title: 'All Day - ' + i,
                  startTime: startTime,
                  endTime: endTime,
                  allDay: true
              });
          } else {
              var startMinute = Math.floor(Math.random() * 24 * 60);
              var endMinute = Math.floor(Math.random() * 180) + startMinute;
              startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() + startDay, 0, date.getMinutes() + startMinute);
              endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate() + endDay, 0, date.getMinutes() + endMinute);
              events.push({
                  title: 'Event - ' + i,
                  startTime: startTime,
                  endTime: endTime,
                  allDay: false
              });
          }
      }
      return events;
  }

  onRangeChanged(ev) {
      console.log('range changed: startTime: ' + ev.startTime + ', endTime: ' + ev.endTime);
  }

  closeModal(withParams: boolean = false) {
      if(withParams == true) {
          this.viewCtrl.dismiss({
              mode: this.mode,
              vacationStart: this.vacationStart,
              vacationEnd: this.vacationEnd,
          });
      } else {
          this.viewCtrl.dismiss({});
      }
  }

  markDisabled = (date:Date) => {
      var current = new Date();
      current.setHours(0, 0, 0);
      return date < current;
  };
}



// WEBPACK FOOTER //
// ./src/pages/vacation-calendar/vacation-calendar.ts